import React, { FC } from 'react';
import { Dialog } from '@monorepo/nova-ui';
import { useMidnightValuesData } from '../../hooks/api';
import { MidnightModalContent, MidnightModalHeader } from './components';

interface MidnightValuesModalProps {
  open: boolean;
  onClose: () => void;
  tsAccountId: string;
}

export const MidnightValuesModal: FC<MidnightValuesModalProps> = ({
  open,
  onClose,
  tsAccountId,
}) => {
  const {
    data: midnightValues,
    isLoading,
    error,
    refetch,
  } = useMidnightValuesData(tsAccountId, open);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="midnight-values-modal-title"
    >
      <MidnightModalHeader />
      <MidnightModalContent
        midnightValues={midnightValues}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
      />
    </Dialog>
  );
};
